import { useEffect, useState } from "react";

/**
 * SSR-safe media query 훅. 서버 및 마운트 전 첫 클라 렌더에서는 항상 `false` 를 반환해
 * hydration mismatch 를 피한다(실제 매칭은 마운트 후 effect 에서 반영).
 *
 * 예: const isMobile = useMediaQuery("(max-width: 860px)");
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
